import { render } from "./resonanceRules.vue?vue&type=template&id=6876d15a&scoped=true"
import script from "./resonanceRules.vue?vue&type=script&lang=js"
export * from "./resonanceRules.vue?vue&type=script&lang=js"

import "./resonanceRules.vue?vue&type=style&index=0&id=6876d15a&scoped=true&lang=css"

import exportComponent from "/home/usuario/Proyectos/2025/ArkhamHorror/App_Arkham_Horror_3/multigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6876d15a"]])

export default __exports__